module.exports = __webpack_public_path__ + "static/media/easibaseImage.ebae09d5.jpg";